$(document).ready(function () {
  console.log("ready");
  /** Mobile Nav Toggle */
  $(".header-links-wrapper .mobile-burger").on("click", function () {
    $(".icon-hamburger").toggleClass("hidden");
    $(".icon-close").toggleClass("hidden");
    $(".header-mobile-dropdown").slideToggle();
  });

  /** Slider Sections */
  $(".testimonial-swiper-wrapper-virtual").on("init", function (event, slick) {
    var swiperHeight = $(this).height();
    $(".testimonial-swiper-wrapper").css("min-height", swiperHeight);
  });

  /** Testimonials Swiper Section */
  $(
    'div[class*="testimonial-swiper-wrapper"], .highlight-swiper-wrapper'
  ).slick({
    centerMode: true,
    centerPadding: "14%",
    slidesToShow: 3,
    swipeToSlide: true,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          centerPadding: "5%",
        },
      },
      {
        breakpoint: 1025,
        settings: {
          centerPadding: "0%",
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerPadding: "26%",
        },
      },
      {
        breakpoint: 648,
        settings: {
          slidesToShow: 1,
          centerPadding: "14%",
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          centerPadding: "2%",
        },
      },
    ],
  });

  function initSlick() {
    $(".as-featured-in-container").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      speed: 4000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      infinite: true,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      swipe: false,
      touchMove: false,
      variableWidth: true,
    });
  }

  initSlick();

  $(window).resize(function () {
    $(".as-featured-in-container").slick("destroy");
    initSlick();
  });

  /** Hero Carousel */
  $(".hero-carousel .hero-container-inner").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    swipe: false,
    touchMove: false,
    autoplaySpeed: 4000,
  });

  /** Recover Password */

  // $("#recover-password-btn").on("click", function (e) {
  //   e.preventDefault();

  //   $("#CustomerLoginForm").addClass("hidden");
  //   $("#RecoverPasswordForm").removeClass("hidden");
  // });

  /* Login */
  // $(".return-login").on("click", function (e) {
  //   e.preventDefault();

  //   $("#CustomerLoginForm").removeClass("hidden");
  //   $("#RecoverPasswordForm").addClass("hidden");
  // });

  $(document).on("click", "#recover-password-btn", function (e) {
    e.preventDefault();
    $("#CustomerLoginForm").addClass("hidden");
    $("#RecoverPasswordForm").removeClass("hidden");
  });

  /* Login */

  $(document).on("click", ".return-login", function (e) {
    e.preventDefault();
    $("#CustomerLoginForm").removeClass("hidden");
    $("#RecoverPasswordForm").addClass("hidden");
  });

  /** Anchor Group Links */
  var offsetHeight = $(".anchor-group-wrapper").outerHeight();
  console.log("Anchor Group Links");

  console.log(offsetHeight);

  /** Scroll Function */
  $(window).scroll(function () {
    var fromTop = $(window).scrollTop() + offsetHeight;

    $(".anchor-group-wrapper a").each(function () {
      var currLink = $(this);
      var refElement = $(currLink.attr("href"));

      if (
        refElement.position().top <= fromTop + 1 &&
        refElement.position().top + refElement.outerHeight() > fromTop
      ) {
        $(".anchor-group-wrapper a").removeClass("active");
        currLink.addClass("active");
      } else {
        currLink.removeClass("active");
      }
    });
  });

  $(".anchor-group-wrapper a").click(function (event) {
    console.log(".anchor-group-wrapper a click");
    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - offsetHeight,
      },
      500
    );
  });

  /** Meal Popup */
  $(".product-meal-item .meal-popup-action").on("click", function () {
    var $this = $(this);
    $this
      .parents(".product-meal-item")
      .find(".meal-popup-box")
      .addClass("show");
    $("body").addClass("overflow-y-hidden");
  });

  $(".meal-popup-box .close-popup").on("click", function () {
    var $this = $(this);
    $this.parents(".meal-popup-box").removeClass("show");
    $("body").removeClass("overflow-y-hidden");
  });

  /** Extra Popup */
  $(document).on("click", ".js-extra-btn", function () {
    $(".extra-meal-selection").addClass("show");
    $("body").addClass("overflow-y-hidden--extra");
  });
  $(".extra-meal-selection .close-popup--extra").on("click", function () {
    $(".extra-meal-selection").removeClass("show");
    $("body").removeClass("overflow-y-hidden--extra");
    $(".plan-checkout-btn").removeClass("js-extra-btn");
    $(".plan-checkout-btn").addClass("js-checkout-btn");
  });

  /** Meal Qty Plan */
  var limitQty = $(".total-meals-limit");
  var limitPrice = $(".total-meals-price");
  var currentQty = $(".current-meals-qty");
  var extraQty = $(".extra-meals-qty");
  var planDay = $("#meal-plan-day");
  var planStep = $("#meal-plan-step");
  var cartParams = [];

  $(".qty-selection-inner .plan-qty-item").on("click", function () {
    var $this = $(this);

    if ($(".js-remove-taster")) {
      $.ajax({
        // Clear Cart
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
          $(".extra-state .extra-meal-qty").text("0");
        },
      });
    }

    // reset all meals
    //$(".meal-qty").val(1);
    //$('.added-detail-summary .qty-minus').click();
    currentQty.val(0).trigger("change");

    limitQty.val(parseInt($this.data("title"))).trigger("change");
    limitPrice.val(parseInt($this.data("price"))).trigger("change");
    planStep.val(2).trigger("change");

    $(".qty-selection-inner .plan-qty-item").removeClass("active");
    $this.addClass("active");
    $(".product-plan.day-select-plan").removeClass("pointer-events-none");

    if (parseInt(limitQty.val()) > parseInt(currentQty.val())) {
      $(".product-meal-item:not(.extra-meal) .add-cart-btn").attr(
        "disabled",
        false
      );
      $(".qty-selection-wrap:not(.extra-meal-qty) .qty-ctrl-btn.qty-plus").attr(
        "disabled",
        false
      );
    }
  });

  // Set default num meals
  let numMealParams = new URLSearchParams(document.location.search);
  let defaultNumMeals = parseInt(numMealParams.get("num"), 0);
  $(".qty-selection-inner .plan-qty-item").each(function(){
    if ($(this).data("title") == defaultNumMeals){
      $(this).trigger("click");
    }
  })

  /** Meal Day Plan */

  $(".day-selectbox-wrap .plan-day-item").on("click", function () {
    var $this = $(this);

    let preSelectedDay = $(".plan-day-item.active").data("day");
    let prevSelectedDate = $(".plan-day-item.active").data("date");
    let prevSelectDeliveryDate = $(".plan-day-item.active").data(
      "deliverydate"
    );

    planDay.val($this.data("day")).trigger("change");

    if (parseInt(planStep.val()) < 3) {
      planStep.val(3).trigger("change");
    }
    $(".day-selectbox-wrap .plan-day-item").removeClass("active");
    $this.addClass("active");
    $(".product-meals.meals-selection").removeClass("pointer-events-none");
    //console.log("change day");
    //handle weekly meals menu
    let selectDeliveryDate = $(".plan-day-item.active").data("deliverydate");
    if (selectDeliveryDate == "04/20/2025") {
      console.log(selectDeliveryDate);
      $("#meal-plan-overlayer").removeClass("hidden");
      $("#meal-plan-overlayer").show();
    }
    let selectDeliveryDataTS = new Date(selectDeliveryDate).getTime();

    $(".weekly-meals-date-tab").removeClass("delivery");
    $(".weekly-meals-date-tab").removeClass("active");
    $(".meals-selection-wrap .meals-grid-wrap").removeClass("delivery");
    $(
      ".meals-selection-wrap .main-meal-selection .meals-grid-wrap .meal-add-cart"
    ).hide();
    var maxWeeklyMealsTab = $(".weekly-meals-date-tab").length;
    for (var i = 1; i <= maxWeeklyMealsTab; i++) {
      var menuStartDateTS = new Date(
        $("#weekly-meals-date-tab-" + i).data("startdate")
      ).getTime();
      var menuEndDateTS = new Date(
        $("#weekly-meals-date-tab-" + i).data("enddate")
      ).getTime();
      console.log(i + " : " + menuStartDateTS + " : " + menuEndDateTS);
      if (
        selectDeliveryDataTS >= menuStartDateTS &&
        selectDeliveryDataTS <= menuEndDateTS
      ) {
        $("#weekly-meals-date-tab-" + i).addClass("delivery");
        $("#weekly-meals-date-tab-" + i).trigger("click");
        $("#weekly-meals-selection-" + i).addClass("delivery");
        $("#weekly-meals-selection-" + i + " .meal-add-cart").show();
      }
    }

    if (prevSelectedDate !== undefined) {
      if (
        !areSameWeeks(
          new Date(prevSelectDeliveryDate),
          new Date(selectDeliveryDate),
          1
        )
      ) {
        console.log("not same week");
        //not same week, clear selected meals
        var mealQty = $(".meal-qty");
        mealQty.val(0).trigger("change");
        $(".extra-meal-qty .value").html("1");
        /* Order Summary */
        var currentQty = $(".current-meals-qty");
        currentQty.val(0).trigger("change");
        $(".add-cart-btn").addClass("active");
        $(".qty-selection-wrap").removeClass("active");
      }
    }
  });

  /** Meal Qty Control */
  $(".product-meal-item .add-cart-btn").on("click", function () {
    var $this = $(this);
    var mealQty = $this.parents(".product-meal-item").find(".meal-qty");

    mealQty.val(1).trigger("change");
    $this.removeClass("active");
    $this.next().addClass("active");

    if ($this.parents(".product-meal-item").hasClass("extra-meal")) {
      extraQty.val(parseInt(extraQty.val()) + 1).trigger("change");
    } else {
      currentQty.val(parseInt(currentQty.val()) + 1).trigger("change");
    }

    if (parseInt(limitQty.val()) == parseInt(currentQty.val())) {
      $(".product-meal-item:not(.extra-meal) .add-cart-btn").attr(
        "disabled",
        true
      );
      $(".qty-selection-wrap:not(.extra-meal-qty) .qty-ctrl-btn.qty-plus").attr(
        "disabled",
        true
      );
    }
  });

  $(".product-meal-item .qty-selection-wrap .qty-minus").on(
    "click",
    function (e) {
      if ($(this).parents(".product-meal-item").hasClass("rc-upsell")) {
        return;
      }
      var mealQty = $(this).parents(".product-meal-item").find(".meal-qty");
      var qtyVal = mealQty.val();

      if (qtyVal > 0) {
        mealQty.val(parseInt(qtyVal) - 1).trigger("change");

        if ($(this).parents(".product-meal-item").hasClass("extra-meal")) {
          extraQty.val(parseInt(extraQty.val()) - 1).trigger("change");
        } else {
          currentQty.val(parseInt(currentQty.val()) - 1).trigger("change");
        }

        if (qtyVal == 1) {
          $(this).parent().removeClass("active");
          $(this).parent().prev().addClass("active");
        } else {
          $(this)
            .next()
            .find(".value")
            .text(parseInt(qtyVal) - 1);
        }

        if (parseInt(limitQty.val()) > parseInt(currentQty.val())) {
          $(".product-meal-item:not(.extra-meal) .add-cart-btn").attr(
            "disabled",
            false
          );
          $(
            ".qty-selection-wrap:not(.extra-meal-qty) .qty-ctrl-btn.qty-plus"
          ).attr("disabled", false);
        }
      }
    }
  );

  $(".product-meal-item .qty-selection-wrap .qty-plus").on(
    "click",
    function () {
      if ($(this).parents(".product-meal-item").hasClass("rc-upsell")) {
        return;
      }
      var mealQty = $(this).parents(".product-meal-item").find(".meal-qty");
      var qtyVal = mealQty.val();

      mealQty.val(parseInt(qtyVal) + 1).trigger("change");

      if ($(this).parents(".product-meal-item").hasClass("extra-meal")) {
        extraQty.val(parseInt(extraQty.val()) + 1).trigger("change");
      } else {
        currentQty.val(parseInt(currentQty.val()) + 1).trigger("change");
      }

      $(this)
        .prev()
        .find(".value")
        .text(parseInt(qtyVal) + 1);

      if (parseInt(limitQty.val()) == parseInt(currentQty.val())) {
        $(".product-meal-item:not(.extra-meal) .add-cart-btn").attr(
          "disabled",
          true
        );
        $(
          ".qty-selection-wrap:not(.extra-meal-qty) .qty-ctrl-btn.qty-plus"
        ).attr("disabled", true);
      }
    }
  );

  /** Order Summary */
  var summaryLimitQty = $(".meals-selection .summary-head .limit-qty");
  var summaryCurrQty = $(".meals-selection .summary-head .current-qty");
  var summaryExtraQty = $(".meals-selection .summary-head .extra-meal-qty");

  // Initiallize
  summaryLimitQty.text(limitQty.val());
  $(".order-summary .summary-description .add-more-desc .value").text(
    parseInt(limitQty.val()) - parseInt(currentQty.val())
  );

  var amountCalculation = () => {
    var leftAmount = parseInt(limitQty.val()) - parseInt(currentQty.val());
    var completedPercent =
      (parseInt(currentQty.val()) / parseInt(limitQty.val())) * 100;
    completedPercent = completedPercent > 100 ? 100 : completedPercent;

    if (leftAmount != parseInt(limitQty.val())) {
      $(".order-summary .empty-summary").addClass("hidden");
      $(".order-summary .added-detail-summary").removeClass("hidden");
    } else {
      $(".order-summary .empty-summary").removeClass("hidden");
      $(".order-summary .added-detail-summary").addClass("hidden");
    }

    if (leftAmount > 0) {
      $(".order-summary .summary-head p").removeClass("show");
      $(".order-summary .summary-head .add-more-desc").addClass("show");
      $(".order-summary .summary-head .add-more-desc .value").text(leftAmount);

      $(".order-summary .summary-description").addClass("hidden");
      $(".order-summary .summary-description .completed-desc").addClass(
        "hidden"
      );
      $(".js-extra-btn").prop("disabled", true);
      $(".js-checkout-btn").prop("disabled", true);
    }

    if (leftAmount === 0) {
      $(".order-summary .summary-description").removeClass("hidden");
      $(".order-summary .summary-head .add-more-desc").addClass("hidden");
      $(".order-summary .summary-description .completed-desc").removeClass(
        "hidden"
      );
      $(".order-summary .add-more-desc").addClass("hidden");
      // planStep.val(3).trigger("change");

      if (currentQty.val() !== "0") {
        $(".js-extra-btn").prop("disabled", false);
        $(".js-checkout-btn").prop("disabled", false);
      }

      if ($(".rc-update-fuel").length) {
        $(".rc-update-fuel").prop("disabled", false);
      }
    }

    if (parseInt(limitQty.val()) != 0 && leftAmount == 0) {
      $(".plan-checkout-btn").attr("disabled", false);
      $(".product-meal-item:not(.extra-meal) .add-cart-btn").attr(
        "disabled",
        true
      );
      $(".qty-selection-wrap:not(.extra-meal-qty) .qty-ctrl-btn.qty-plus").attr(
        "disabled",
        true
      );
    } else {
      $(".plan-checkout-btn").attr("disabled", true);
      $(".product-meal-item:not(.extra-meal) .add-cart-btn").attr(
        "disabled",
        false
      );
      $(".qty-selection-wrap:not(.extra-meal-qty) .qty-ctrl-btn.qty-plus").attr(
        "disabled",
        false
      );
    }

    if (leftAmount < 0) {
      $(".order-summary .summary-description p").removeClass("show");
      $(".order-summary .summary-description .too-many-desc").addClass("show");
    }

    $(".order-summary .summary-progressbar .progress-val").css(
      "width",
      completedPercent + "%"
    );

    if (completedPercent > 0) {
      $(".order-summary .summary-progressbar").addClass("bg-convert");
    } else {
      $(".order-summary .summary-progressbar").removeClass("bg-convert");
    }
  };

  amountCalculation();

  // Changing
  limitQty.change(function () {
    summaryLimitQty.text($(this).val());
    amountCalculation();
  });

  summaryCurrQty.text(currentQty.val());
  currentQty.change(function () {
    summaryCurrQty.text($(this).val());
    amountCalculation();
  });

  summaryExtraQty.text(
    ($(".checkout-info .total-price .value").text() - limitPrice.val())
      .toFixed(2)
      .replace(/[.,]00$/, "")
  );

  extraQty.change(function () {
    var extraPriceCalc = 0;

    $(".product-meal-item.extra-meal").each(function () {
      var $this = $(this);
      var price = $this.find(".meal-qty").data("price");
      var qty = $this.find(".meal-qty").val();

      //console.log(`${extraPriceCalc} - ${price} - ${qty}`);

      extraPriceCalc = extraPriceCalc + price * qty;
    });

    var totalPrice = +limitPrice.val() + +extraPriceCalc;
    summaryExtraQty.text(extraPriceCalc.toFixed(2).replace(/[.,]00$/, ""));

    $(".order-checkout .checkout-info .value").text(
      totalPrice.toFixed(2).replace(/[.,]00$/, "")
    );
  });

  // Added Meals Trigger
  $(".product-meal-item .meal-qty").each(function () {
    var $this = $(this);

    var mealQtyCtrler = () => {
      var addedMeal = $this;
      var itemWrap = addedMeal.parent(".product-meal-item");
      var mealVariantID = addedMeal.attr("id");
      var mealTitle = addedMeal.data("title");
      var mealPrice = addedMeal.data("price");
      var qtySelection = $(
        ".added-detail-summary .qty-ctrl-clone .qty-selection-wrap"
      ).clone();

      if (itemWrap.hasClass("extra-meal"))
        qtySelection.addClass("extra-meal-qty");

      if (addedMeal.val() > 0) {
        var mealItem = $(
          '.added-detail-summary .detail-lists > div[id*="' +
            mealVariantID +
            '"]'
        );
        var title = $('<p class="meal-title bold">' + mealTitle + "</p>");
        var price = $('<span class="meal-price">£' + mealPrice + "</span>");
        var priceQtyWrap = $('<dive class="price-qty-wrap"></dive>');
        priceQtyWrap.append(qtySelection);
        priceQtyWrap.append(price);
        priceQtyWrap.find(".qty-selection-wrap .value").text(addedMeal.val());
        var newMealList = $(
          '<div id="' + mealVariantID + '-meal" class="meal-item"></div>'
        );

        newMealList.append(title);
        newMealList.append(priceQtyWrap);

        if (mealItem.length > 0) {
          mealItem.find(".qty-selection-wrap .value").text(addedMeal.val());
        } else {
          $(".added-detail-summary .detail-lists").append(newMealList);
        }

        if (cartParams.some((item) => item.id === mealVariantID)) {
          cartParams.map((param) => {
            if (param.id == mealVariantID) param.quantity = addedMeal.val();
          });
        } else {
          cartParams.push({
            id: mealVariantID,
            quantity: addedMeal.val(),
          });
        }
      } else {
        $("#" + mealVariantID + "-meal").remove();

        cartParams = $.grep(cartParams, function (e) {
          return e.id != mealVariantID;
        });
      }
    };

    mealQtyCtrler();
    $this.change(function () {
      mealQtyCtrler();
    });
  });

  $(document).on(
    "click",
    ".added-detail-summary .meal-item .qty-selection-wrap .qty-minus",
    function () {
      console.log("dded-detail-summary qty-minus");
      var $this = $(this);
      var variantID = $this
        .parents(".meal-item")
        .attr("id")
        .replace("-meal", "");

      if ($this.parent().hasClass("extra-meal-qty")) {
        $(".extra-meal-selection")
          .find("input#" + variantID)
          .parent(".product-meal-item")
          .find(".qty-minus")
          .click();
      } else {
        $(".meals-grid-wrap.delivery")
          .find("input#" + variantID)
          .parent(".product-meal-item")
          .find(".qty-minus")
          .click();
      }
    }
  );

  $(document).on(
    "click",
    ".added-detail-summary .meal-item .qty-selection-wrap .qty-plus",
    function () {
      console.log("dded-detail-summary qty-plus");
      var $this = $(this);
      var variantID = $this
        .parents(".meal-item")
        .attr("id")
        .replace("-meal", "");
      if ($this.parent().hasClass("extra-meal-qty")) {
        $(".extra-meal-selection")
          .find("input#" + variantID)
          .parent(".product-meal-item")
          .find(".qty-minus")
          .click();
      } else {
        $(".meals-grid-wrap.delivery")
          .find("input#" + variantID)
          .parent(".product-meal-item")
          .find(".qty-plus")
          .click();
      }
    }
  );

  /** Plan Steps */
  // $('.order-checkout .checkout-info .value').text(limitPrice.val());
  limitPrice.change(function () {
    console.log("limitPrice.change");
    if (parseInt(extraQty.val()) > 0) {
      var extraPriceCalc = 0;
      $(".product-meal-item.extra-meal").each(function () {
        var $this = $(this);
        var price = $this.find(".meal-qty").data("price");
        var qty = $this.find(".meal-qty").val();

        extraPriceCalc = extraPriceCalc + parseInt(price) * parseInt(qty);
      });

      var totalPrice = parseInt(limitPrice.val()) + extraPriceCalc;

      $(".order-checkout .checkout-info .value").text(
        totalPrice.toFixed(2).replace(/[.,]00$/, "")
      );
    } else {
      $(".order-checkout .checkout-info .value").text(
        parseFloat(limitPrice.val())
          .toFixed(2)
          .replace(/[.,]00$/, "")
      );
    }
  });

  planDay.change(function () {
    if (planDay.val() == "Sun") {
      $(".order-checkout .checkout-info .fuel-plan-price .desc").text(
        "P&P £4.95"
      );
    } else {
      $(".order-checkout .checkout-info .fuel-plan-price .desc").text(
        "Free P&P"
      );
    }
  });

  planStep.change(function () {
    $(".order-steps .step").each(function () {
      var $this = $(this);

      if (
        parseInt(planStep.val()) < 3 &&
        $(".order-steps .meals-step").hasClass("current-step")
      )
        return;

      $this.removeClass("before-step current-step passed-step");
      if (parseInt(planStep.val()) == $this.data("step"))
        $this.addClass("current-step");
      if (parseInt(planStep.val()) > $this.data("step"))
        $this.addClass("passed-step");
      if (parseInt(planStep.val()) < $this.data("step"))
        $this.addClass("before-step");

      if (planStep.val() == 3) {
        $(".order-checkout .checkout-info").removeClass("hidden");
      }
    });
  });

  /** Mobile Summary Popup */
  $(".mobile-summary-nav").on("click", function () {
    $(".meals-selection .order-summary").addClass("show");
  });

  $(".mobile-close-summary").on("click", function () {
    $(".meals-selection .order-summary").removeClass("show");
  });

  /** Weekly Menu Tab **/

  $(".weekly-meals-date-tab").on("click", function () {
    console.log("weekly-meals-date-tab click");
    $(".weekly-meals-date-tab").removeClass("active");
    $(this).addClass("active");
    $(".main-meal-selection .meals-grid-wrap").hide();
    $("#weekly-meals-selection-" + $(this).data("idx")).show();
  });

  /** Meal Type Filtering */
  $(".meal-filter-wrap .type-filter-btn").on("click", function () {
    var $this = $(this);
    var current_collection_id = $this.parent().parent().attr("id");
    $collection_list_obj = $("#" + current_collection_id);

    var typeFilterString = [];

    if ($this.hasClass("active") && $this.data("type") != "All") {
      $this.removeClass("active");
      $collection_list_obj
        .find(".meal-filter-info")
        .text($('[data-type="All"]').data("desc"));
    } else {
      $this
        .parents(".meal-filter-wrap")
        .find(".type-filter-btn")
        .removeClass("active");
      $this.addClass("active");
      $collection_list_obj.find(".meal-filter-info").text($this.data("desc"));
    }

    if ($this.data("type") == "All") {
      $collection_list_obj
        .find(".meals-grid-wrap .product-meal-item")
        .each(function () {
          var $this = $(this);
          $this.removeClass("hide");
          typeFilterString.length = 0;
        });
      $collection_list_obj.find(".meal-filter-info").text($this.data("desc"));
    } else {
      console.log("not all");
      $collection_list_obj
        .find(".meal-filter-wrap .type-filter-btn")
        .each(function () {
          var $this = $(this);

          if ($this.hasClass("active")) {
            typeFilterString.push($this.data("type"));
          } else {
            typeFilterString = $.grep(typeFilterString, function (value) {
              return value != $this.data("type");
            });
          }

          $collection_list_obj
            .find(".meals-grid-wrap .product-meal-item")
            .removeClass("hide");

          if (typeFilterString.length > 0) {
            $collection_list_obj
              .find(".meals-grid-wrap .product-meal-item")
              .each(function () {
                var $this = $(this);
                var mealTags = $this.data("type");
                let hasAllElems = true;

                for (let i = 0; i < typeFilterString.length; i++) {
                  //console.log(typeFilterString);
                  //console.log(mealTags);
                  if (!mealTags.includes(typeFilterString[i])) {
                    hasAllElems = false;
                    break;
                  }
                }

                if (hasAllElems) {
                  $this.removeClass("hide");
                } else {
                  $this.addClass("hide");
                }
              });
          }
        });
    }
  });

  /** Meal Tag Filtering */
  $(".meal-filter-wrap .tags-filter").on("click", function () {
    $(".meal-filter-tags").addClass("show");
    $("body").addClass("overflow-y-hidden");
  });

  $(".meal-filter-tags .filter-heading .close-filter").on("click", function () {
    $(".meal-filter-tags").removeClass("show");
    $("body").removeClass("overflow-y-hidden");
  });

  $(".meal-filter-tags .tag-filter-btn").on("click", function () {
    var $this = $(this);
    //console.log($this);
    //var current_collection_id = $this.parent().parent().parent().parent().parent().parent().parent().attr("id");
    var current_collection_id = $this
      .parents(".main-meal-selection")
      .attr("id");
    $collection_list_obj = $("#" + current_collection_id);
    //console.log(current_collection_id);
    var tagFilterString = [];

    if ($this.hasClass("clicked")) {
      $this.removeClass("clicked");
    } else {
      // $this.parents(".filter-group-item").find(".tag-filter-btn").removeClass("clicked");
      $this.addClass("clicked");
    }

    $collection_list_obj
      .find(".meal-filter-tags .tag-filter-btn")
      .each(function () {
        var $this = $(this);

        if ($this.hasClass("clicked")) {
          if ($this.data("tag") == "fish") {
            tagFilterString.push($this.data("tag") + ",");
          } else {
            tagFilterString.push($this.data("tag"));
          }
        } else {
          tagFilterString = $.grep(tagFilterString, function (value) {
            return value != $this.data("tag");
          });
        }

        $collection_list_obj
          .find(".meals-grid-wrap .product-meal-item")
          .removeClass("hide");

        if (tagFilterString.length > 0) {
          $collection_list_obj
            .find(".meals-grid-wrap .product-meal-item")
            .each(function () {
              var $this = $(this);
              var mealTags = $this.data("tags");
              let hasAllElems = true;

              for (let i = 0; i < tagFilterString.length; i++) {
                if (!mealTags.includes(tagFilterString[i])) {
                  hasAllElems = false;
                  break;
                }
              }

              if (hasAllElems) {
                $this.removeClass("hide");
              } else {
                $this.addClass("hide");
              }
            });
        }
      });
  });

  /** Chef's Selection */
  $(".meal-chef-selection").on("click", function () {
    console.log("meal-chef-selection click");
    var selectionNum = limitQty.val();
    console.log("selectionNum: " + selectionNum);

    if ($('[data-tag="gluten free"]').hasClass("clicked")) {
      $(
        ".main-meal-selection .meals-grid-wrap.delivery .product-meal-item"
      ).each(function () {
        var $this = $(this);
        //if (chef_collection_gluten.includes($this.data("product-id"))) {
        //dairy_free_selectiongluten_free_selectionmeat_free_selection
        var mealTags = $this.data("tags");
        if (mealTags.includes("gluten_free_selection")) {
          $this.attr("data-chef", true);
        } else {
          $this.removeAttr("data-chef");
        }
      });
    } else if ($('[data-tag="dairy free"]').hasClass("clicked")) {
      $(
        ".main-meal-selection .meals-grid-wrap.delivery .product-meal-item"
      ).each(function () {
        var $this = $(this);

        //if (chef_collection_dairy.includes($this.data("product-id"))) {
        //dairy_free_selectiongluten_free_selectionmeat_free_selection
        var mealTags = $this.data("tags");
        if (mealTags.includes("dairy_free_selection")) {
          $this.attr("data-chef", true);
        } else {
          $this.removeAttr("data-chef");
        }
      });
    } else if ($('[data-tag="meat free"]').hasClass("clicked")) {
      $(
        ".main-meal-selection .meals-grid-wrap.delivery .product-meal-item"
      ).each(function () {
        var $this = $(this);

        //if (chef_collection_meat.includes($this.data("product-id"))) {
        //dairy_free_selectiongluten_free_selectionmeat_free_selection
        var mealTags = $this.data("tags");
        if (mealTags.includes("meat_free_selection")) {
          $this.attr("data-chef", true);
        } else {
          $this.removeAttr("data-chef");
        }
      });
    } else {
      $(
        ".main-meal-selection .meals-grid-wrap.delivery .product-meal-item"
      ).each(function () {
        var $this = $(this);

        //if (chef_collection_all.includes($this.data("product-id"))) {
        var mealTags = $this.data("tags");
        if (mealTags.includes("chefs")) {
          $this.attr("data-chef", true);
        } else {
          $this.removeAttr("data-chef");
        }
      });
    }

    var chefProducts = $(
      ".main-meal-selection .meals-grid-wrap.delivery .product-meal-item[data-chef=true]"
    );

    chefProducts.sort(function (a, b) {
      var contentA = parseInt($(a).data("chef-sort"));
      var contentB = parseInt($(b).data("chef-sort"));
      return contentA < contentB ? -1 : contentA > contentB ? 1 : 0;
    });
    console.log("sorted");
    console.log(chefProducts);

    // if ($('[data-tag="gluten free"]').hasClass("clicked")) {
    //   //gluten free only
    //   chefProducts.each(function(idx){
    //     if (!$(this).data("tags").toLowerCase().includes("gluten free")){
    //       //$(this).remove();
    //     }

    //   })
    // } else if ($('[data-tag="dairy free"]').hasClass("clicked")) {
    //   // dairy free only
    // } else if ($('[data-tag="meat free"]').hasClass("clicked")) {
    //   // meat free only
    // } else {
    //   // do nothing
    // }

    // chefProducts.each(function () {
    //     var $this = $(this);
    //     console.log($this.find("input:nth-child(1)").data("title"));
    //   });

    if (chefProducts.length == 0) return;

    if (chefProducts.length > selectionNum) {
      chefProducts.each(function (index) {
        var $this = $(this);
        $this.find(".meal-add-cart .add-cart-btn").click();
        //console.log($this.find(".meal-title").html());
        //console.log("index: "+index);

        return index < selectionNum - 1;
      });
    } else {
      var leftCount = selectionNum - chefProducts.length;
      var remainder = leftCount % chefProducts.length;

      chefProducts.each(function () {
        var $this = $(this);
        $this.find(".meal-add-cart .add-cart-btn").click();
      });

      for (let i = 0; i < Math.floor(leftCount / chefProducts.length); i++) {
        chefProducts.each(function () {
          var $this = $(this);
          $this.find(".meal-add-cart .qty-selection-wrap .qty-plus").click();
        });
      }

      if (remainder > 0) {
        chefProducts.each(function (index) {
          var $this = $(this);
          $this.find(".meal-add-cart .qty-selection-wrap .qty-plus").click();

          return index < remainder - 1;
        });
      }
    }
  });

  /** Checkout */
  $(document).on("click", ".js-checkout-btn", function () {
    console.log("� ~ file: theme.js [597] ~ cartParams =>", cartParams);

    let queryParams = cartParams;
    let reversedParams = [];
    let day = $(".plan-day-item.active").data("day");
    let date = $(".plan-day-item.active").data("date");
    let preference = "All";

    let mainProduct = "";

    for (let i = queryParams.length - 1; i >= 0; i--) {
      reversedParams.push(queryParams[i]);
    }

    if ($(".filter-group-item--preference .tag-filter-btn.clicked").length) {
      preference = $(
        ".filter-group-item--preference .tag-filter-btn.clicked.tag-name"
      ).text();
    }

    if ($(".plan-qty-item.active").length) {
      // Fuel Box
      let index = $(".plan-qty-item.active").data("index");

      if (day == "Wed") {
        reversedParams.push(window.fb_wed[index]);
        mainProduct = window.fb_wed[index];
      } else if (day == "Thu") {
        reversedParams.push(window.fb_thu[index]);
        mainProduct = window.fb_thu[index];
      } else if (day == "Fri") {
        reversedParams.push(window.fb_fri[index]);
        mainProduct = window.fb_fri[index];
      } else if (day == "Sun") {
        reversedParams.push(window.fb_sun[index]);
        mainProduct = window.fb_sun[index];
      }
    } else {
      // no qty selected. use default
      if (day == "Wed") {
        reversedParams.push(window.fb_wed[0]);
        mainProduct = window.fb_wed[0];
      } else if (day == "Thu") {
        reversedParams.push(window.fb_thu[0]);
        mainProduct = window.fb_thu[0];
      } else if (day == "Fri") {
        reversedParams.push(window.fb_fri[0]);
        mainProduct = window.fb_fri[0];
      } else if (day == "Sun") {
        reversedParams.push(window.fb_sun[0]);
        mainProduct = window.fb_sun[0];
      }
    }
    //console.log(mainProduct);
    if ("54834750587253" == mainProduct.id) {
      reversedParams.push({ id: "54842348208501", quantity: 1 });
      reversedParams.push({ id: "54835516047733", quantity: 2 });
      reversedParams.push({ id: "49629246783787", quantity: 2 });
    }

    if ($('[data-tag="gluten free"]').hasClass("clicked")) {
      preference = "Gluten Free";
    } else if ($('[data-tag="dairy free"]').hasClass("clicked")) {
      preference = "Dairy Free";
    } else if ($('[data-tag="meat free"]').hasClass("clicked")) {
      preference = "Meat Free";
    }

    $.ajax({
      // Clear Cart
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      beforeSend: function () {
        $("#loader").removeClass("hidden");
      },
      success: function () {
        $.ajax({
          // Add items to Cart
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: reversedParams,
          },
          dataType: "json",
          success: function (response) {
            let mainProductInCart = true;
            $.each(response.items, function (key, value) {
              //alert(value.com);
              //console.log(value.id+" : "+mainProduct.id);
              if (value.id == mainProduct.id) {
                mainProductInCart = true;
              }
            });
            if (mainProductInCart) {
              $.ajax({
                // Attach Date, Preference
                type: "POST",
                url: "/cart/update.js",
                data: {
                  attributes: {
                    "Delivery Date": date,
                    Preference: preference,
                    "First Delivery": date,
                    "Taster Box": "",
                  },
                },
                dataType: "json",
                success: function () {
                  window.location.href = "/checkout";
                },
              });

              //end update.js
            }
          },
        });
      },
    });
  });

  $(".extra-meal-selection").on("click", function (e) {
    if (
      !$(e.target).is(
        ".extra-meal-selection-inner, .extra-meal-selection-inner *"
      )
    ) {
      $(".extra-meal-selection .close-popup").click();
    }
  });

  /** Checkout Reminder */
  if (window.checkout_reminder) {
    planStep.val(3).trigger("change");
    $(".order-checkout .checkout-info").removeClass("hidden");
  }

  // Register Customer account
  $(document).on("click", ".js-create-account", function (e) {
    if (
      $('input[name="customer[password]"]').val() !=
      $('input[name="customer[password_confirmation]"]').val()
    ) {
      e.preventDefault();
      alert("Passwords do not match.");
    } else {
      $(this).parents("form").submit();
    }
  });

  // Choose fuel - customer portal
  $(document).on("click", ".js-rc-choose-meal", function () {
    $(".total-meals-limit").val($(".subscription-qty").data("qty"));
    $(".limit-qty").text($(".subscription-qty").data("qty"));
    //$("body").addClass("locked");
    //$(".choose-fuel-popup").addClass("show");
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".extra-meal-selection-inner").offset().top,
    }, 300);
  });

  $(".choose-fuel-popup .close-popup").on("click", function () {
    var $this = $(this);
    $this.parents(".choose-fuel-popup").removeClass("show");
    $("body").removeClass("locked");
  });

  $(document).on("click", ".js-rc-update-fuel", function () {
    console.log("js-rc-update-fuel click");
    // console.log(ReCharge.Novum.subscription);
    // console.log(ReCharge.Novum.subscription.email);

    function addMeal(index) {
      if (index >= cartParams.length) {
        //$("#loader").addClass("hidden");
        document.querySelectorAll(".js-rc-update-fuel").forEach((btn) => {
          btn.disabled = true;
          btn.remove();
        });

        document.querySelector(".summary-details").remove();
        document.querySelector(".summary-description").remove();

        ReCharge.Toast.addToast(
          "Success",
          "Successfully updated your next Weekly Meal Prep Box."
        );
        // setTimeout(function(){
        //   window.location.reload();
        // },1000);
        $("#rc-referral-overlay").removeClass("hidden");

        return;
      }
      (async () => {
        let addressId = ReCharge.Novum.subscription.address_id;
        let nextChargeDate =
          ReCharge.Novum.subscription.next_charge_scheduled_at;
        let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes?token=${window.customerToken}`;
        let variantId = cartParams[index].id;
        let quantity = cartParams[index].quantity;

        let data = {
          shopify_variant_id: variantId,
          address_id: addressId,
          quantity: quantity,
          next_charge_scheduled_at: nextChargeDate,
        };

        /*
          await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            header: '"Content-Type", "application/json"'
          }).then(response => response.json()).then(reponse => {
            console.log(response);
          });
          */

        try {
          const response = await axios.post(url, data).then((response) => {
            // Successful request made
            console.log("Attempted add onetime, response from api:");
            //console.log(response.data);

            $(".rc-onetimes").append(`
                <div class="rc-meals__row" data-onetime-id="${response.data.onetime.id}" data-product-id="${response.data.onetime.shopify_product_id}" data-variant-id="${response.data.onetime.shopify_variant_id}">
                  ${response.data.onetime.product_title} x ${response.data.onetime.quantity}
                </div>
              `);

            addMeal(index + 1);
          });

          /*start new add meals flow*/

          // const data = {
          //   "id":ReCharge.Novum.customer.shopify_customer_id,
          //   "email":ReCharge.Novum.subscription.email,
          //   "challengeHash":challengeData.hash,
          //   "customerHash":ReCharge.Novum.customer.hash,
          //   "cid":ReCharge.Novum.customer.id,
          //   "aid":ReCharge.Novum.subscription.address_id,
          //   "sid":ReCharge.Novum.subscription.id,
          //   "nextChargeDate":ReCharge.Novum.subscription.next_charge_scheduled_at,
          //   "onetime":cartParams[index]
          // }
          // console.log(data);

          // //const url = "https://fuelhub-order.herokuapp.com/recharge/onetimes/create";
          // var url = "https://fuelhub-order.herokuapp.com/recharge/onetimes/create";

          // if (cartParams[index].isCampaign == true){
          //    url = "https://fuelhub-order.herokuapp.com/recharge/campaign/onetimes/create";
          // }

          // try {

          //   $.post(url,data,
          //     function(data, status){
          //       console.log("Data: " + data + "\nStatus: " + status);
          //       if (data.data.success){
          //         $(".rc-onetimes").append(`
          //           <div class="rc-meals__row" data-onetime-id="${data.data.onetime.id}" data-product-id="${data.data.onetime.shopify_product_id}" data-variant-id="${data.data.onetime.shopify_variant_id}">
          //             ${data.data.onetime.product_title} x ${data.data.onetime.quantity}
          //           </div>
          //         `);

          //         addMeal(index + 1);
          //       } else {
          //         setTimeout(() => {
          //           const loadingTitle = document.querySelector("#loader h2");
          //           const loadingText = document.querySelector("#loader p");
          //           const loadingSpinner = document.querySelector("#loader .spinner");

          //           loadingTitle.innerHTML = "Something went wrong.";
          //           loadingText.innerHTML = "Please contact support to ensure your meals get to you on time.";
          //           loadingSpinner.style.display = "none";
          //         }, 4000);
          //       }

          //   });

          /*end new add meals flow*/
        } catch (error) {
          // Request failed
          console.error(error);

          if (!!error) {
            setTimeout(() => {
              const loadingTitle = document.querySelector("#loader h2");
              const loadingText = document.querySelector("#loader p");
              const loadingSpinner = document.querySelector("#loader .spinner");

              loadingTitle.innerHTML = "Something went wrong.";
              loadingText.innerHTML =
                "Please contact support to ensure your meals get to you on time.";
              loadingSpinner.style.display = "none";
            }, 4000);
          }

          //addMeal(index);
        }
      })();
    }
    $(".choose-fuel-popup").removeClass("show");
    $("#loader").removeClass("hidden");
    $("body").removeClass("locked");
    $(".rc-meals__note").hide();
    $(".js-rc-choose-meal").hide();
    $(".choose-extras").show();

    //msrc
    if (
      window._msrc != null &&
      window._msrc == "true" &&
      window._msrc_name != null &&
      window._msrc_name != ""
    ) {
      // cartParams.push({id:'54835516047733', quantity:"1", isCampaign:true, properties:[{ _msrc:window._msrc_name}]});
      // console.log(cartParams);
    }

    addMeal(0);
  });

  //update preference
  $(document).on("click", ".js-update-preference", function () {
    console.log($("#rc_preference").val());
    let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/addresses/${onetimeId}?token=${window.customerToken}`;
    let data = {
      note_attributes: [""],
    };

    $("#loader").find(".loader-message h2").html("PROCESSING");
    $("#loader").find(".loader-message p").html("This may take a few seconds.");
    $("#loader").removeClass("hidden");

    (async () => {
      try {
        let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/addresses/${onetimeId}?token=${window.customerToken}`;
        let data = {
          note_attributes: [""],
        };

        //const response = await axios.post(url, data);
        // Successful request made
        //window.location.reload();
      } catch (error) {
        // Request failed
        console.error(error);
      }
    })();
  });

  // removeAllOneTime
  $(document).on("click", ".js-rc-remove-meals", function () {
    $("#rc-confirm-overlay").removeClass("hidden");
  });
  $(document).on("click", ".js-rc-remove-meals-confirm", function () {
    console.log("js-rc-remove-meals-confirm");

    (async () => {
      $("#rc-confirm-overlay").addClass("hidden");
      $("#loader").find(".loader-message h2").html("PROCESSING");
      $("#loader")
        .find(".loader-message p")
        .html("This may take a few seconds.");
      $("#loader").removeClass("hidden");
      try {
        const schema = ReCharge.Schemas.charges.plusOnetimes(
          ReCharge.Novum.subscription.address_id,
          ReCharge.Novum.subscription.id
        );

        const url = `${ReCharge.Endpoints.request_objects()}&schema=${schema}`;

        const response = await axios.post(url);
        // Successful request made
        //console.log(response.data);
        if (response.data.hasOwnProperty("onetimes")) {
          for (const onetime of response.data.onetimes) {
            console.log("remove onetime: " + onetime.id);
            await removeOnetime(onetime.id);
          }
        }

        console.log("removed all");
        window.location.reload();
      } catch (error) {
        // Request failed
        console.error(error);
      }
    })();
  });

  async function removeOnetime(onetimeId) {
    let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}/cancel?token=${window.customerToken}`;

    try {
      const response = await axios.post(url);
    } catch (error) {
      // Request failed
      console.error(error);
    }
  }

  // Add onetime purchase
  $(document).on("click", ".js-rc-upsell-add", function () {
    let variantId = $(this).data("variant-id");
    let addressId = ReCharge.Novum.subscription.address_id;
    let nextChargeDate = ReCharge.Novum.subscription.next_charge_scheduled_at;

    if ($(this).hasClass("added")) {
      // Remove product
      $(this).addClass("loading");
      let onetimeId = $(`.rc-extras__row[data-variant-id="${variantId}"]`).data(
        "onetime-id"
      );
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}/cancel?token=${window.customerToken}`;

      (async () => {
        try {
          const response = await axios.post(url);
          // Successful request made
          console.log("Attempted remove onetime, response from api:");
          console.log(response.data);

          $(this).removeClass("loading");
          $(this).removeClass("added");
          $(this).addClass("active");
          $(this).parent().find(".rc-upsell-qty").removeClass("active");

          $(`.rc-extras__row[data-onetime-id="${onetimeId}"]`).remove();

          ReCharge.Toast.addToast(
            "Success",
            "Successfully removed from next box"
          );
        } catch (error) {
          // Request failed
          console.error(error);
        }
      })();
    } else {
      // Add product
      $(this).addClass("loading");
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes?token=${window.customerToken}`;

      (async () => {
        let data = {
          shopify_variant_id: variantId,
          address_id: addressId,
          quantity: 1,
          next_charge_scheduled_at: nextChargeDate,
        };

        try {
          const response = await axios.post(url, data);
          // Successful request made
          console.log("Attempted add onetime, response from api:");
          console.log(response.data);

          $(this).removeClass("loading");
          $(this).addClass("added");
          $(this).removeClass("active");
          $(this).parent().find(".rc-upsell-qty").addClass("active");
          $(".rc-onetimes").append(`
              <div class="rc-extras__row" data-onetime-id="${
                response.data.onetime.id
              }" data-product-id="${
            response.data.onetime.shopify_product_id
          }" data-variant-id="${response.data.onetime.shopify_variant_id}">
                <span class="extras__title">${
                  response.data.onetime.product_title
                } x 1</span>
                <span class="extras__price">${ReCharge.Novum.Utils.getCurrency()}${
            response.data.onetime.price
          }</span>
              </div>
            `);

          ReCharge.Toast.addToast("Success", "Successfully added to next box");
        } catch (error) {
          // Request failed
          console.error(error);
        }
      })();
    }
    /*
      fetch("/tools/recurring/access", {
        headers: {
            "x-recharge-storefront-access-token": "sk_1x1_bf85fda4c1e82f0f8df804b8d7602a3d77f6587f727b75949a84e62d5b01ca38"
        }
      }).then(response => response.json()).then(json => {
  
        var myHeaders = new Headers();
        myHeaders.append("X-Recharge-Version", "2021-11");
        myHeaders.append("X-Recharge-Access-Token", json.api_token);
        myHeaders.append("Content-Type", "application/json");
    
        var data = JSON.stringify({"batch_type":"onetime_create"});
  
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: data,
          redirect: 'follow'
        };
  
        fetch("https://api.rechargeapps.com/async_batches?shop_url=" + Shopify.shop, requestOptions)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
  
        var url = "https://api.rechargeapps.com/async_batches?shop_url=" + Shopify.shop;
        fetch(url, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "X-Recharge-Access-Token": 'sk_1x1_bf85fda4c1e82f0f8df804b8d7602a3d77f6587f727b75949a84e62d5b01ca38',
            "X-Recharge-Version": "2021-11",
            "Content-Type": "application/json"
          },
          body: '{"batch_type":"onetime_create"}'
        }).then(response => response.json())
          .then(json => {
            console.log(json);
          });
      });
      */
  });

  // Update onetime quantity
  $(document).on("click", ".rc-upsell-qty__minus", function () {
    let value = parseInt(
      $(this).parents(".rc-upsell-qty").find(".value").text()
    );
    let newValue = value - 1;
    let variantId = $(this).parents(".rc-upsell-qty").data("variant-id");

    let onetimeId = $(`.rc-extras__row[data-variant-id="${variantId}"]`).data(
      "onetime-id"
    );

    $(this).parents(".rc-upsell-qty").addClass("disabled");

    if (newValue == 0) {
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}/cancel?token=${window.customerToken}`;

      (async () => {
        try {
          const response = await axios.post(url);
          // Successful request made
          console.log("Attempted remove onetime, response from api:");
          console.log(response.data);

          $(this).parents(".rc-upsell-qty").removeClass("disabled");
          $(this).parents(".rc-upsell-qty").find(".value").text(newValue);
          $(this).parents(".rc-upsell-qty").removeClass("active");
          $(this)
            .parents(".meal-add-cart")
            .find(".rc-upsell-add")
            .addClass("active");
          $(this)
            .parents(".meal-add-cart")
            .find(".rc-upsell-add")
            .removeClass("added");

          $(`.rc-extras__row[data-onetime-id="${onetimeId}"]`).remove();

          ReCharge.Toast.addToast(
            "Success",
            "Successfully removed from next box"
          );
        } catch (error) {
          // Request failed
          console.error(error);
        }
      })();
    } else {
      let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}?token=${window.customerToken}`;

      (async () => {
        let data = {
          quantity: newValue,
        };

        try {
          const response = await axios.post(url, data);
          // Successful request made
          console.log("Attempted update onetime, response from api:");
          console.log(response.data);

          $(this).parents(".rc-upsell-qty").removeClass("disabled");
          $(this).parents(".rc-upsell-qty").find(".value").text(newValue);

          $(
            `.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__title`
          ).text(
            `${response.data.onetime.product_title} x ${response.data.onetime.quantity}`
          );
          $(
            `.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__price`
          ).text(
            `${ReCharge.Novum.Utils.getCurrency()}${(
              response.data.onetime.price * response.data.onetime.quantity
            ).toFixed(2)}`
          );
          ReCharge.Toast.addToast("Success", "Successfully updated quantity");
        } catch (error) {
          // Request failed
          console.error(error);
        }
      })();
    }
  });

  $(document).on("click", ".rc-upsell-qty__plus", function () {
    let value = parseInt(
      $(this).parents(".rc-upsell-qty").find(".value").text()
    );
    let newValue = value + 1;
    let variantId = $(this).parents(".rc-upsell-qty").data("variant-id");

    let onetimeId = $(`.rc-extras__row[data-variant-id="${variantId}"]`).data(
      "onetime-id"
    );
    let url = `/tools/recurring/portal/${ReCharge.Novum.customer.hash}/onetimes/${onetimeId}?token=${window.customerToken}`;

    $(this).parents(".rc-upsell-qty").addClass("disabled");

    (async () => {
      let data = {
        quantity: newValue,
      };

      try {
        const response = await axios.post(url, data);
        // Successful request made
        console.log("Attempted update onetime, response from api:");
        console.log(response.data);

        $(this).parents(".rc-upsell-qty").removeClass("disabled");
        $(this).parents(".rc-upsell-qty").find(".value").text(newValue);

        $(
          `.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__title`
        ).text(
          `${response.data.onetime.product_title} x ${response.data.onetime.quantity}`
        );
        $(
          `.rc-extras__row[data-onetime-id="${response.data.onetime.id}"] .extras__price`
        ).text(
          `${ReCharge.Novum.Utils.getCurrency()}${(
            response.data.onetime.price * response.data.onetime.quantity
          ).toFixed(2)}`
        );
        ReCharge.Toast.addToast("Success", "Successfully updated quantity");
      } catch (error) {
        // Request failed
        console.error(error);
      }
    })();
  });

  /* Klaviyo newsletter popup */
  $(document).on("click", ".js-discount-popup", function () {
    console.log("Klaviyo newsletter popup click");
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "Vdwrcp"]);
  });

  // NEW UPDATE BITS

  const burgerButton = document.querySelector(".js-burger-toggle");

  const header = document.querySelector(".js-header");

  burgerButton.addEventListener("click", () => {
    burgerButton.classList.toggle("is-open");
    header.classList.toggle("header--nav-open");
  });

  const heroBgImages = document.querySelectorAll(".js-hero-background-images");

  heroBgImages.forEach((hero) => {
    const fadeItems = hero.querySelectorAll("div");
    let currentIndex = 0;

    function fadeInNext() {
      fadeItems[currentIndex].style.opacity = 0; // Fade out the current item
      currentIndex = (currentIndex + 1) % fadeItems.length;
      fadeItems[currentIndex].style.opacity = 1; // Fade in the next item
    }

    // Initial fade-in
    fadeItems[currentIndex].style.opacity = 1;

    // Set up a timer to cycle through the divs
    setInterval(fadeInNext, 3000); // Change every 3 seconds (adjust as needed)
  });

  const heroTitle = document.querySelectorAll(".js-hero-titles");

  heroTitle.forEach((title) => {
    const fadeItems = title.querySelectorAll("div");
    let currentIndex = 0;

    function hideAllExceptCurrent() {
      for (let i = 0; i < fadeItems.length; i++) {
        if (i !== currentIndex) {
          fadeItems[i].style.display = "none";
        }
      }
    }

    function showNext() {
      fadeItems[currentIndex].style.display = "none";
      currentIndex = (currentIndex + 1) % fadeItems.length;
      fadeItems[currentIndex].style.display = "block";
    }

    // Initially hide all divs except the first one
    hideAllExceptCurrent();

    // Set up a timer to switch to the next div
    setInterval(function () {
      showNext();
    }, 1500); // Change every 3 seconds (adjust as needed)
  });

  // Find the start and end sections by their class names
  var startSection = document.querySelector(".js-section-background-start");
  var endSection = document.querySelector(".js-section-background-end");

  // Check if both startSection and endSection were found
  if (startSection && endSection) {
    // Create a new section element to serve as the container
    var containerSection = document.createElement("section");

    // Add a class to the container section
    containerSection.className = "background-texture";

    //Add padding
    var bgTexturePaddingTop = 100;
    var paddingElem = $(".js-section-background-start-content");
    console.log("padding: " + paddingElem.data("padding"));
    if (paddingElem.data("padding") >= 0) {
      bgTexturePaddingTop = paddingElem.data("padding");
    }

    var bgTexturePaddingBottom = 100;
    paddingElem = $(".js-section-background-end-content");
    if (paddingElem.data("padding") >= 0) {
      bgTexturePaddingBottom = paddingElem.data("padding");
    }
    containerSection.style.paddingTop = bgTexturePaddingTop + "px";
    containerSection.style.paddingBottom = bgTexturePaddingBottom + "px";

    // Reference to the parent node of startSection
    var parentNode = startSection.parentNode;

    // Loop through the siblings of startSection until endSection is reached
    var foundEndSection = false;
    var currentNode = startSection.nextSibling;
    while (currentNode) {
      if (currentNode === endSection) {
        foundEndSection = true;
        break;
      }
      if (currentNode.nodeType === 1) {
        // Check if it's an element node
        containerSection.appendChild(currentNode.cloneNode(true)); // Clone the node
        parentNode.removeChild(currentNode); // Remove the original node
      }
      currentNode = startSection.nextSibling;
    }

    // Insert the container section before the endSection if it was found
    if (foundEndSection) {
      parentNode.insertBefore(containerSection, endSection);

      /** Meal Popup */
      $(".product-meal-item .meal-popup-action").on("click", function () {
        var $this = $(this);
        $this
          .parents(".product-meal-item")
          .find(".meal-popup-box")
          .addClass("show");
        $("body").addClass("overflow-y-hidden");
      });

      $(".meal-popup-box .close-popup").on("click", function () {
        var $this = $(this);
        $this.parents(".meal-popup-box").removeClass("show");
        $("body").removeClass("overflow-y-hidden");
      });
    } else {
      console.error("End section not found between start and end markers.");
    }
    /** Accordiion */
    $(".accordions .accordion-heading").on("click", function (e) {
      $this = $(this);
      $target = $this.next(".accordion-content");

      if (!$this.hasClass("active")) {
        $this
          .parents(".accordions")
          .find(".accordion-heading")
          .removeClass("active");
        $this.parents(".accordions").find(".accordion-content").slideUp();
        // $('.accordions .accordion-heading').removeClass('active');
        // $('.accordions .accordion-content').slideUp();
        $this.addClass("active");
        $target.slideDown();
      } else {
        $this.removeClass("active");
        $target.slideUp();
      }

      return false;
    });
  } else {
    console.error("Start and/or end section not found.");
    /** Accordiion */
    $(".accordions .accordion-heading").on("click", function (e) {
      $this = $(this);
      $target = $this.next(".accordion-content");

      if (!$this.hasClass("active")) {
        $this
          .parents(".accordions")
          .find(".accordion-heading")
          .removeClass("active");
        $this.parents(".accordions").find(".accordion-content").slideUp();
        // $('.accordions .accordion-heading').removeClass('active');
        // $('.accordions .accordion-content').slideUp();
        $this.addClass("active");
        $target.slideDown();
      } else {
        $this.removeClass("active");
        $target.slideUp();
      }

      return false;
    });
  }

  function horizontalDrag() {
    const sliders = document.querySelectorAll(".js-grab-scroll");

    sliders.forEach((slider) => {
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener("mousedown", (e) => {
        // Check if the click occurred within an element with class "popup-info"
        if (e.target.closest(".meal-popup-box")) {
          return;
        }

        isDown = true;
        slider.classList.add("cursor-grabbing");
        slider.classList.remove("cursor-grab");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("cursor-grabbing");
        slider.classList.add("cursor-grab");
      });

      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("cursor-grabbing");
        slider.classList.add("cursor-grab");
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;

        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
      });
    });
  }

  horizontalDrag();

  //footer mobile menu expand
  $(".footer__navs nav > div:not(.footer__social) .h3").each(function () {
    $(this).click(function () {
      if ($(window).width() <= 768) {
        if ($(this).parent().hasClass("open")) {
          $(this).parent().removeClass("open");
        } else {
          $(this).parent().addClass("open");
        }
      }
    });
  });

  //footer menu meal plan expan
  $(".footer__navs nav .footer__navs-parent").click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(
        '.footer__navs nav .footer__navs-child[data-parent="' +
          $(this).attr("id") +
          '"]'
      ).css("display", "none");
    } else {
      $(this).addClass("open");
      $(
        '.footer__navs nav .footer__navs-child[data-parent="' +
          $(this).attr("id") +
          '"]'
      ).css("display", "block");
    }
  });

  //header menu expan
  $(".desktop-header-menu-parent").click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(
        '.desktop-header-menu-child[data-parent="' + $(this).attr("id") + '"]'
      ).css("display", "none");
    } else {
      //$(".desktop-header-menu-parent").removeClass("open");
      //$('.desktop-header-menu-child').css("display","none");
      $(this).addClass("open");
      $(
        '.desktop-header-menu-child[data-parent="' + $(this).attr("id") + '"]'
      ).css("display", "block");
    }
  });

  $(".header__mobile-nav .pushNav_parent").click(function () {
    var subMenu = $(this)
      .parent()
      .find('.pushNav_level[data-parent="' + $(this).attr("id") + '"]');
    console.log(subMenu);
    if ($(subMenu).length > 0) {
      $(subMenu).first().css({ display: "block", left: "100%" });
      $(subMenu)
        .first()
        .animate(
          {
            opacity: 1,
            left: "0%",
          },
          300,
          function () {
            // Animation complete.
          }
        );
    }
  });
  $(".go-back").click(function () {
    $(this)
      .parent()
      .animate(
        {
          opacity: 0,
          left: "100%",
        },
        300,
        function () {
          // Animation complete.
          $(this).css("display", "none");
        }
      );
  });

  // heroCarouselText();


  let _urlParams = new URLSearchParams(document.location.search);
  // let defaultNumMeals = parseInt(_urlParams.get("num"), 0);
  
  // $(".qty-selection-inner .plan-qty-item").each(function(){
  //   if ($(this).data("title") == defaultNumMeals){
  //     $(this).trigger("click");
  //   }
  // })

  let defaulFilter = _urlParams.get("filter");
  if (defaulFilter == "lite"){
    $(".type-filter-btn").each(function(){
      if ($(this).data("type") == "low-cal"){
        var _btn = $(this);
        setTimeout(function(){
          console.log("defaulFilter: "+$(_btn).data("type"));
          $(_btn).trigger("click");
        }, 100)
        
      }
    })
  }
  if (defaulFilter == "chefs"){
    $(".type-filter-btn").each(function(){
      if ($(this).data("type") == "chefs"){
        var _btn = $(this);
        setTimeout(function(){
          console.log("defaulFilter: "+$(_btn).data("type"));
          $(_btn).trigger("click");
        }, 100)
        
      }
    })
  }



  
   

});// end ready

/** Cart Expiry **/
document.addEventListener("DOMContentLoaded", () => {
  function checkCartExpiry() {
    // Get the cookie value
    const cookieValue = document.cookie
      .split("; ")
      .find((cookie) => cookie.startsWith("cart="))
      .split("=")[1];

    if (!!cookieValue) {
      // Parse the cookie date
      const expirationDate = new Date(cookieValue);
      // Calculate two weeks before the expiration date
      const twoWeeksBefore = new Date(expirationDate);
      twoWeeksBefore.setDate(expirationDate.getDate() - 14);
      // Get the current date
      const currentDate = new Date();
      // Calculate the difference in hours between currentDate and twoWeeksBefore
      const timeDifferenceHours =
        (currentDate - twoWeeksBefore) / (1000 * 60 * 60);
      // Check if the time difference is greater than 48 hours
      if (timeDifferenceHours >= 48) {
        // Delete the cart cookie
        document.cookie =
          "cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }
    }
  }
  //checkCartExpiry();
});

/*buy now */
function BuyNow(vIds) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    success: function () {
      console.log(vIds);
      var vidArr = vIds.split(",");

      console.log(vidArr);
      var items = [];
      for (var i = 0; i < vidArr.length; i++) {
        items.push({ id: vidArr[i], quantity: 1 });
      }
      console.log(items);
      var itemsData = { items: items };
      console.log(itemsData);

      var checkout_url = "/checkout";

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: itemsData,
        dataType: "json",
        success: function () {
          window.location.href = checkout_url;
        },
      });
    },
  });
}

function areSameWeeks(date1, date2, boundaryDay = 0) {
  console.log("check same week?");
  if (date1 > date2) {
    let t = date1;
    date1 = date2;
    date2 = t;
  }

  if ((date2 - date1) / 1000 / 3600 / 24 > 6) {
    return false;
  }

  let day1 = date1.getUTCDay();
  let day2 = date2.getUTCDay();

  if (day1 == boundaryDay) {
    return true;
  }

  if (day2 == boundaryDay) {
    return false;
  }

  let d1BoundaryDist = (day1 - boundaryDay + 7) % 7;
  let d2BoundaryDist = (day2 - boundaryDay + 7) % 7;

  if (d1BoundaryDist <= d2BoundaryDist) {
    return true;
  }

  return false;
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function heroCarouselText() {
  const titles = document.querySelectorAll(".hero-carousel-content__title");
  let index = 0;

  function fadeInOutTitles() {
    titles[index].style.opacity = 1;
    setTimeout(() => {
      titles[index].style.opacity = 0;
      index = (index + 1) % titles.length;
      fadeInOutTitles();
    }, 2000);
  }

  fadeInOutTitles();
}